import React, { useEffect, useState } from "react";
import { Modal, Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
  getDepartmentDropdown,
  getEmployeeDropdown,
  getGroupMasterInfo,
  getUnitDropdown,
  saveGroup,
} from "../../services/Group/GroupServices";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import InputField from "../../../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import CommonTransactionTable from "../../../../../common/components/CommonTable/CommonTransactionTable";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
import { DeleteIcon } from "../../../../../assets/CommonAssets";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

const schema = yup.object().shape({
  unit: yup.object().nullable().required("Unit is required"),

  department: yup.object().nullable().required("Department is required"),
  groupName: yup.string().required("Group Name is required"),
});

const GroupMasterModal = ({
  GroupMasterModalOpen,
  setGroupMasterModalOpen,
  selectedRow,
  setSelectedRow,
  setGroupMasterList,
  GroupMasterList,
  openBackDrop,
  setOpenBackdrop,
  populateTable,
}) => {
  const {
    control,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      department: null,
      groupName: "",
      staff: null,
    },
  });

  const [tableData, setTableData] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [unitDropDown, setUnitDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [employeeDropdown, setEmployeeDropdown] = useState([]);
  const selectedStaff = watch("staff");
  let unit = watch("unit");
  let department = watch("department");

  useEffect(() => {
    if (!selectedStaff) return;

    setTableData((prev) => {
      const alreadyAdded = prev.some((emp) => emp.id === selectedStaff.id);
      if (alreadyAdded) return prev;

      return [
        ...prev,
        {
          id: selectedStaff.id,
          Staff: selectedStaff.label,
        },
      ];
    });

    setValue("staff", null);
  }, [selectedStaff, setValue]);

  useEffect(() => {
    if (selectedRow !== null) {
      setOpenBackdrop(true);
      getGroupMasterInfo(selectedRow?.["Group Id"])
        .then((res) => res.data)
        .then((res) => {
          if (res.statusCode === 200) {
            let finalData = JSON.parse(res?.result);
            // setSelectedRowPatchData(finalData);
            if (finalData !== null) {
              setValue("unit", finalData?.unit);
              setValue("department", finalData?.department);
              setValue("groupName", finalData?.["group_name"]);
              console.log("finalData?.employees", tableData);
              finalData?.employees?.length > 0 &&
                setTableData((prev) => [...prev, ...finalData?.employees]);
            }
          }
        })
        .catch((err) => errorAlert(err.message))
        .finally(() => setOpenBackdrop(false));
    }
  }, [selectedRow]);

  const handleDeleteStaff = (row) => {
    setTableData((prev) => prev.filter((emp) => emp?.id !== row?.id));
  };

  const renderActionsEmp = (row) => (
    <button type={"button"} onClick={() => handleDeleteStaff(row)}>
      <DeleteIcon sx={{ color: "#D11A2A", cursor: "pointer" }} />
    </button>
  );

  const onSubmit = () => {
    if (tableData.length === 0) {
      errorAlert("Please add at least one staff member");
      return;
    }
    setOpenConfirmModal(true);
  };

  // const handleFinalSubmit = () => {
  //   const employees = tableData.map((emp) => ({
  //     id: emp.id,
  //     Staff: emp.Staff,
  //   }));

  //   const finalObject = {
  //     departmentId: watch("department")?.id || null,
  //     groupName: watch("groupName"),
  //     employees,
  //   };

  //   setGroupMasterList([...GroupMasterList, finalObject]);

  //   successAlert("Data submitted successfully");
  //   setOpenConfirmModal(false);
  //   setGroupMasterModalOpen(false);
  //   reset();
  //   setTableData([]);
  //   setSelectedRow(null);
  // };
  const handleFinalSubmit = () => {
    const employees = tableData.map((emp) => ({
      id: emp.id,
      Staff: emp.Staff,
    }));

    const finalData = [
      {
        departmentId: watch("department")?.id || null,
        groupName: watch("groupName"),
        employees,
      },
    ];

    setGroupMasterList((prev) => [...prev, ...finalData]);
    setOpenConfirmModal(false);
    setGroupMasterModalOpen(false);
    setSelectedRow(null);
    successAlert("Data submitted successfully");
    reset();
    setTableData([]);
  };
  useEffect(() => {
    getUnitDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setUnitDropdown(res.result);
        }
      })
      .catch((error) => errorAlert(error.message));
  }, []);

  useEffect(() => {
    if (unit?.id) {
      getDepartmentDropdown(unit?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            setDepartmentDropdown(res.result);
          }
        })
        .catch((error) => errorAlert(error.message));
    }
  }, [unit]);
  useEffect(() => {
    if (department?.id) {
      getEmployeeDropdown(department?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            setEmployeeDropdown(res.result);
          }
        })
        .catch((error) => errorAlert(error.message));
    }
  }, [department]);
  const handleSaveRecord = () => {
    const employees = tableData.map((emp) => {
      return { employee: { id: emp?.id } };
    });
    let obj = {
      id: selectedRow !== null ? selectedRow?.["Group Id"] : null,
      group: watch("groupName"),
      unit: watch("unit")
        ? {
            id: watch("unit")?.id,
          }
        : null,
      department: watch("department")
        ? {
            id: watch("department")?.id,
          }
        : null,
      employeeId: employees,
      isActive: true,
    };

    setOpenConfirmModal(false);
    // setTrainingScheduleModalOpen(false);
    setOpenBackdrop(true);
    setOpenConfirmModal(false);
    saveGroup(obj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setGroupMasterModalOpen(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res?.message);
          setOpenBackdrop(false);
          setTableData([]);
          reset();
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  return (
    <>
      <Modal open={GroupMasterModalOpen}>
        <Box sx={modalStyle}>
          <div className="flex justify-between items-center p-2 border-b">
            <h2 className="text-lg font-semibold">Group</h2>
            <CloseModalIcon
              className="cursor-pointer"
              onClick={() => {
                setGroupMasterModalOpen(false);
                setSelectedRow(null);
                reset();
                setTableData([]);
              }}
            />
          </div>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex-1 overflow-y-auto p-3"
          >
            <div className="grid grid-cols-3 gap-2">
              <DropdownField
                control={control}
                name="unit"
                placeholder="Search by Unit*"
                dataArray={unitDropDown}
                isSearchable
                isClearable
                error={errors?.unit}
              />
              <DropdownField
                control={control}
                name="department"
                placeholder="Search by Department*"
                dataArray={departmentDropdown}
                isSearchable
                isClearable
                error={errors?.department}
              />

              <InputField
                name="groupName"
                label="Group Name*"
                control={control}
                error={errors?.groupName}
              />
            </div>

            <div className="grid grid-cols-2 gap-2 my-4">
              <SearchDropdown
                dataArray={employeeDropdown}
                control={control}
                name="staff"
                placeholder="Search Staff"
                isClearable
                isSearchable
                searchIcon={true}
                handleInputChange={() => {}}
                onChange={() => {}}
              />
            </div>

            <div className="mt-2 h-[240px] md:w-[50%]">
              {tableData.length > 0 ? (
                <CommonTransactionTable
                  highlightRow={false}
                  dataResult={tableData}
                  renderActions={renderActionsEmp}
                  removeHeaders={["id"]}
                />
              ) : (
                <div className="flex justify-center pt-6 font-bold text-gray-600">
                  No Records Found...
                </div>
              )}
            </div>

            <div className="pt-4 mt-4 flex justify-end gap-2">
              <CommonButton
                label="Reset"
                type="button"
                onClick={() => {
                  reset();
                  setTableData([]);
                }}
                className="px-6 py-2 border border-red-500 text-red-500"
              />

              <CommonButton
                label={selectedRow ? "Update" : "Save"}
                type="submit"
                className="px-6 py-2 bg-green-700 text-white"
              />
            </div>
          </form>
        </Box>
      </Modal>

      <ConfirmationModal
        confirmationOpen={openConfirmModal}
        confirmationHandleClose={() => setOpenConfirmModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to submit this group?"
        confirmationSubmitFunc={handleSaveRecord}
        confirmationButtonMsg="Submit"
      />
    </>
  );
};

export default GroupMasterModal;
